const MOBILE_BREAKPOINT = 576;

function bindAccordion(sectionClick, sectionContent) {
    if (!sectionClick || !sectionContent) {
        return;
    }

    // Bind the click handler exactly once. openAccordion() runs on init and on
    // every resize, so binding here would otherwise stack a new listener each
    // time and multi-fire the on_page_link_click event on a single tap.
    if (sectionClick.dataset.awardsAccordionBound === 'true') {
        return;
    }
    sectionClick.dataset.awardsAccordionBound = 'true';

    sectionClick.addEventListener('click', function () {
        if (window.innerWidth > MOBILE_BREAKPOINT) {
            return;
        }

        sectionClick.classList.toggle('active');

        const isOpen = sectionContent.style.height === '0px' || !sectionContent.style.height;

        // Recompute height at click time so it stays correct if the content or
        // viewport changed since load.
        sectionContent.style.height = isOpen ? sectionContent.scrollHeight + 'px' : '0px';

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'on_page_link_click',
            elementPlacement: 'in-content',
            elementClicked: 'accordion',
            pageUrl: window.location.href,
            position: 'single',
            linkText: sectionClick.textContent.trim() || 'Accordion Section',
            direction: isOpen ? 'open' : 'close',
        });
    });
}

function resetDesktopHeight(sectionContent) {
    if (sectionContent && window.innerWidth > MOBILE_BREAKPOINT) {
        sectionContent.style.height = '';
    }
}

function accordions() {
    return [
        [document.querySelector('.system-award-title'), document.querySelector('.awards-accordion')],
        [document.querySelector('.securescore-rate .score .arrow'), document.querySelector('.bar-rating-bars-wrapper')],
    ];
}

export default function init() {
    accordions().forEach(([sectionClick, sectionContent]) => {
        bindAccordion(sectionClick, sectionContent);
        resetDesktopHeight(sectionContent);
    });

    window.addEventListener('resize', function () {
        // Only recompute layout on resize; the click handler is already bound.
        accordions().forEach(([, sectionContent]) => resetDesktopHeight(sectionContent));
    });
}
